import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import withLogin from "../with-login";
import { BffDataAU } from "../../../service";
import Loader from "../../shared/loader";
import TradeInGetOffer from "../trade-in-get-offer";
import TradeInAnotherCar from "../trade-in-another-car";
import TradeInValuationExpired from "../trade-in-valuation-expired";
import { redirectToUrl } from "../../../utils/helpers/redirect-to-url";
import { appUrl } from "../../../constants/url-constants";

const MyAccountTradeIn = ({
    isLoggedIn,
    openLoginPopupConnect,
    setOnLoginCloseCallback,
    secureToken,
    setOnLoginSuccessCallback
}) => {

    const [unBooked, setUnBooked] = useState({
        data: null,
        step: null
    });
    const [isLoading, setIsLoading] = useState(false);

    const { expired = false } = unBooked?.data || {};

    const getUnBookedSellOrderInfo = async (token) => {
        setIsLoading(true);
        try {
            const response = await BffDataAU.getUnbookedSellbooking(token);
            if (response.data && response.data.tradeDto && response.data.tradeDto.tradeInServiceProviderId) {
                setUnBooked({
                    data: response.data.tradeDto,
                    step: response.data.step
                });
            }
        } catch (err) {
            setUnBooked(null);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!isLoggedIn) {
            openLoginPopupConnect();
            setOnLoginSuccessCallback(() => {
                getUnBookedSellOrderInfo(secureToken);
            });
            setOnLoginCloseCallback(() => {
                redirectToUrl(appUrl());
            });
        } else {
            getUnBookedSellOrderInfo(secureToken);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    const renderTradeInScreen = () => {
        if (!expired && unBooked?.data && unBooked?.step) {
            return <TradeInAnotherCar tradeInData={unBooked.data}  step={unBooked.step}/>;
        } else if (unBooked?.data  && expired) {
            return <TradeInValuationExpired />;
        } else {
            return <TradeInGetOffer />;
        }
    };
    return (
        (isLoading) ?
            <Loader /> :
            <React.Fragment>
                {renderTradeInScreen()}
            </React.Fragment>
    );
};

MyAccountTradeIn.propTypes = {
    isLoggedIn: PropTypes.bool,
    openLoginPopupConnect: PropTypes.func,
    setOnLoginCloseCallback: PropTypes.func,
    tradeInData: PropTypes.object,
    setOnLoginSuccessCallback: PropTypes.func,
    secureToken: PropTypes.string
};

export default withLogin(MyAccountTradeIn);

